// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"44fc1e58","703":"673a96a8","787":"acfdbe54"}[chunkId] + ".chunk.js";
};